<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { getBlock } from '@/core/block-registry';
import { useLiveEditorStore } from '@/modules/live-editor/stores/live-editor.store';
import { useBlockEdit } from '@/modules/live-editor/composables/block-edit.composable';
import BlockEdit from '@/modules/live-editor/components/content-blocks/BlockEdit.vue';

const { editingBlock } = storeToRefs(useLiveEditorStore());

const blockDefinition = computed(() => {
   if (!editingBlock.value) return null;
   return getBlock(editingBlock.value.type);
});

const blockComponent = computed(() => blockDefinition.value?.components.edit);

const blockEdit = computed(() => {
   if (!blockDefinition.value?.schema) return null;
   return useBlockEdit(blockDefinition.value.schema());
});
</script>

<template>
   <BlockEdit
      v-if="blockEdit && blockComponent"
      :editing-block="blockEdit.editingBlock"
      :editing-block-definition="blockEdit.editingBlockDefinition"
      :draft-data="blockEdit.draftData"
      @on-save="blockEdit.handleSave"
      @on-discard="blockEdit.handleDiscard"
      @on-remove="blockEdit.handleRemove"
   >
      <component :is="blockComponent" v-model="blockEdit.draftData.value" :errors="blockEdit.errors.value" />
   </BlockEdit>
</template>
